import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FormatDownloadOption } from '@payments/models/invoice-downloads';
import { ARDocFormat, IsrDocFormat } from '@usf/payment-types';

@Component({
  selector: 'app-invoice-download-modal',
  templateUrl: './invoice-download-modal.component.html',
  styleUrls: ['./invoice-download-modal.component.scss'],
})
export class InvoiceDownloadModalComponent {
  @Input() isTouch: boolean;
  @Input() showBasicFormats = true;
  @Input() downloadOptions: FormatDownloadOption[];

  @Output() downloadFormat: EventEmitter<IsrDocFormat | ARDocFormat>;

  selectedFormat: IsrDocFormat | ARDocFormat = null;

  constructor(private modalController: ModalController) {}

  download() {
    this.downloadFormat.emit(this.selectedFormat);
    this.dismiss();
  }

  async dismiss() {
    await this.modalController.dismiss();
  }
}
